import * as actionTypes from "./ApprovalTypes";

const INITIAL_STATE = {
    approvalList: [],
    userList: [],
    approvalProcessList: [],
    approvalStep: null,
    approverTypes: [],
    approverList: [],
    fieldList: [],
    conditionList: [],
    attachments: [],
    failedApprovalList: [],
    approvalBasicFilterData: [],
    failedApprovalBasicFilterData: []
};

const ApprovalReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETAPPROVALLIST:
            return {
                ...state,
                approvalList: action.payload.list,
            };
        case actionTypes.SETUSERLIST:
            return {
                ...state,
                userList: action.payload.list,
            };
        case actionTypes.SETAPPROVALPROCESSLIST:
            return {
                ...state,
                approvalProcessList: action.payload.list,
            };
        case actionTypes.SETAPPROVALSTEP:
            return {
                ...state,
                approvalStep: action.payload.data,
            };
        case actionTypes.SETAPPROVERTYPELIST:
            return {
                ...state,
                approverTypes: action.payload.list,
            };
        case actionTypes.SETAPPROVERLIST:
            return {
                ...state,
                approverList: action.payload.list,
            };
        case actionTypes.SETFIELDLIST:
            return {
                ...state,
                fieldList: action.payload.list,
            };
        case actionTypes.SETCONDITIONLIST:
            return {
                ...state,
                conditionList: action.payload.list,
            };
        case actionTypes.CLEARCONDITIONLIST:
            return {
                ...state,
                conditionList: [],
            };
        case actionTypes.SETATTACHMENTS:
            return {
                ...state,
                attachments: action.payload.list,
            };
        case actionTypes.SETFAILEDAPPROVALLIST:
            return {
                ...state,
                failedApprovalList: action.payload.list,
            };
        case actionTypes.SETAPPROVALBASICFILTERDATA:
            return {
                ...state,
                approvalBasicFilterData: { ...action.payload }
            };
        case actionTypes.SETFAILEDAPPROVALBASICFILTERDATA:
            return {
                ...state,
                failedApprovalBasicFilterData: { ...action.payload }
            };
        default:
            return state;
    }
}

export default ApprovalReducer;